module.exports = __webpack_public_path__ + "img/role-back.aa7daffe.png";